// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2544":"151702f5","4557":"ebe02f78","9835":"452f4505","9925":"c8b141a9"}[chunkId] + ".chunk.css";
};